exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".secret-text{\r\n    text-align: justify;\r\n}\r\n\r\n.secret-around{\r\n    padding-top:40px;\r\n}\r\n\r\n.caret-down-secret{\r\n    padding-bottom:60px;\r\n    text-align: center;\r\n    font-size: 30px;\r\n    cursor: pointer;\r\n}\r\n\r\n.caret-down-secret span{\r\n    font-size: 13px !important;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/agreement/agreement.component.css
// module id = ../../../../../src/app/directive/agreement/agreement.component.css
// module chunks = main